<template lang="pug">
  div
    template(v-if="loading")
      v-row
        v-col(
          v-for="(item, idx) in +skeletonItemsCount"
          v-bind="colsProps"
          :key="idx"
        )
          v-skeleton-loader(:type="skeletonType")

    template(v-else)
      template(v-if="hasItems")
        slot

      template(v-else)
        slot(name="no-data")
          v-card(flat color="transparent")
            v-card-text.pt-0 {{ noDataText }}
</template>

<script>
export default {
  props: {
    colsProps: {
      type: Object,
      default: () => ({
        xl: 3, md: 4, sm: 6, cols: 12,
      }),
    },
    skeletonItemsCount: {
      type: [String, Number],
      default: 6,
    },
    noDataText: {
      type: String,
      default: 'Данный отсутствуют',
    },
    skeletonType: {
      type: String,
      required: true,
    },
    hasItems: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

  },
};
</script>
